import { render, staticRenderFns } from "./BatchesManager.vue?vue&type=template&id=04589f9e&"
import script from "./BatchesManager.vue?vue&type=script&lang=ts&"
export * from "./BatchesManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports